// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.placeholder {
  background: #ffff00;
  padding: 4px 2px;
  outline-offset: -2px;
  line-height: 1em;
  margin: 0 1px;
}

.placeholder::selection {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/custom/placeholder.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":["\n.placeholder {\n  background: #ffff00;\n  padding: 4px 2px;\n  outline-offset: -2px;\n  line-height: 1em;\n  margin: 0 1px;\n}\n\n.placeholder::selection {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
